import type { DraggedLayout, RestrictedZone } from './plugin/types';

// This store is not redux and is mutable to not cause performance overhead on mousemove

interface State {
  restrictedZones: RestrictedZone[];
  draggedLayout: DraggedLayout[];
}

const store: State = {
  restrictedZones: [],
  draggedLayout: null,
};

export const getRestrictedZones = () => store.restrictedZones;
export const getDraggedLayout = () => store.draggedLayout;

export const setRestrictedZones = (payload: RestrictedZone[]) =>
  (store.restrictedZones = payload);
export const setDraggedLayout = (payload: DraggedLayout[]) =>
  (store.draggedLayout = payload);
